import { RxMagicWand } from '@react-icons/all-files/rx/RxMagicWand'
import upperFirst from 'lodash/upperFirst'
import React from 'react'

import { Badge } from 'components/ds'

import SubscriptionRow from './subscription-row'

export type BillingPeriod = 'monthly' | 'annual'

type Props = {
  /** Null for periods the app doesn't support yet (3 or 6 months, 2 or 3 years) */
  period: BillingPeriod | null
  /** Next renewal date, already formatted */
  renewsOn: string | null
  /** Scheduled cancellation date, already formatted */
  expiresOn: string | null
}

/** Billing cycle and next renewal; monthly plans get the annual billing offer, annual ones its status. */
const BillingPeriodRow = ({
  period,
  renewsOn,
  expiresOn,
}: Props): React.ReactNode => {
  const isMonthly = period === 'monthly'

  const dateLabel = expiresOn
    ? `expires on ${expiresOn}`
    : `renews on ${renewsOn}`
  const subtitle = period
    ? `${isMonthly ? 'Monthly' : 'Annual'}, ${dateLabel}`
    : upperFirst(dateLabel)

  const annualBillingLabel = isMonthly
    ? 'Save 10% with annual billing'
    : 'Saving 10% with annual billing'

  return (
    <SubscriptionRow
      title="Billing period"
      subtitle={subtitle}
      aside={
        !expiresOn &&
        period && (
          <Badge color="green" size="1">
            {isMonthly && <RxMagicWand size={12} aria-hidden />}
            {annualBillingLabel}
          </Badge>
        )
      }
    />
  )
}

export default BillingPeriodRow
